import { cn } from "@/utils/styles";

type SignupTickProps = {
  active: boolean;
};

export const SignupTick: React.FC<SignupTickProps> = ({ active }) => {
  return (
    <div
      className={cn(
        "flex size-[14px] flex-row items-center justify-center rounded-full border ",
        active ? "border-gray-dark-1300" : "border-gray-dark-1200"
      )}
    >
      {active && <div className="size-[8px] rounded-full bg-white"></div>}
    </div>
  );
};
